import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Card, CardBody, Col, Input, Label, Row } from "reactstrap"
import { AvField, AvForm } from "availity-reactstrap-validation"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import {
  getBrands,
  getDistricts,
  getInspectionsBooking,
  getModels,
  getStates,
  getUsers,
  getVariants,
  getVehicles,
  updateInspection,
} from "store/actions"
import { useParams } from "react-router-dom"
import { useHistory } from "react-router-dom"
import { InspectionDocumentsParameters } from "./parameters"

function UpdateForm({ updateData }) {
  const dispatch = useDispatch()
  const params = useParams()
  const history = useHistory()

  const isTablet = window.innerWidth <= 768

  const [isFeatured, setIsFeatured] = useState(false)
  const [status, setStatus] = useState("diesel")

  const [vehicleId, setVehicleId] = useState("")

  const [modelValue, setModelValue] = useState("Select Model...")
  const [modelId, setModelValueId] = useState()
  const [modelSearch, setModelSearch] = useState("")

  const [brandValue, setBrandValue] = useState("Select Brand...")
  const [brandId, setBrandId] = useState()
  const [brandSearch, setBrandSearch] = useState("")

  const [varientValue, setVarientValue] = useState("Select Variant...")
  const [variantId, setVariantId] = useState()
  const [varientSearch, setVarientSearch] = useState("")

  const [state, setState] = useState("Select State")
  const [stateId, setStateId] = useState("")
  const [stateSearch, setStateSearch] = useState("")

  const [district, setDistrict] = useState("Select District")
  const [districtId, setDistrictId] = useState(null)
  const [districtSearch, setDistrictSearch] = useState("")

  const [staff, setStaff] = useState("Select Staff...")
  const [staffId, setStaffId] = useState(null)
  const [staffSearch, setStaffSearch] = useState("")

  const [booking, setBooking] = useState("Select Booking...")
  const [bookingId, setBookingId] = useState(null)
  const [bookingSearch, setBookingSearch] = useState("")

  const {
    inspectionDetails,
    model,
    brand,
    varient,
    allState,
    allDistricts,
    allUser,
    AllInspectionBookings,
    loadingCreate,
  } = useSelector(state => ({
    inspectionDetails: state.Inspection?.inspectionDetails,
    model: state.Model.models?.models,
    brand: state.Brand.brands?.brands,
    varient: state.Varient.variants?.variants,
    allState: state?.Client?.states?.States,
    allDistricts: state?.Client?.districts?.districts,
    allUser: state.Members.users,
    AllInspectionBookings: state.Inspection.inspectionsBooking?.bookings,
    loadingCreate: state.Inspection.loadingCreate,
  }))

  useEffect(() => {
    dispatch(getModels(1, 10, modelSearch, brandId))
  }, [modelSearch, brandId])

  useEffect(() => {
    dispatch(getBrands(1, "", 10, brandSearch))
  }, [brandSearch])

  useEffect(() => {
    dispatch(getVariants(1, 10, varientSearch, modelId))
  }, [varientSearch, modelId])

  useEffect(() => {
    dispatch(getVehicles("", "", "", "", "", "", "", "", "", "", "", ""))
  }, [dispatch])

  const [customerName, setCustomerName] = useState("")
  const [customerPhone, setCustomerPhone] = useState("")

  useEffect(() => {
    setCustomerName(updateData?.owner_details?.customer_name || "")
    setCustomerPhone(updateData?.owner_details?.phone_number || "")
  }, [updateData])

  const handleSubmit = (e, values) => {
    const inspection = {
      inspection_data: {
        inspected_date: values?.inspected_date,
        inspected_by: staffId || null,
        inspection_number: updateData?.inspection_data?.inspection_number,
      },
      vehicle_data: {
        vehicle_number: values?.vehicle_number,
        vehicle_name: values?.vehicle_name,
        vehicle_brand: brandId || null,
        vehicle_model: modelId || null,
        vehicle_variant: variantId || null,
        variant_name: values?.vehicle_variant_text || null,
        vehicle_year: values?.vehicle_year,
        current_kilometer: values?.current_kilometer,

        vehicle_fuel_type: status?.value,
      },
      owner_details: {
        customer_name: customerName,
        phone_number: customerPhone,
        address: values?.address,
        district: districtId || null,
        state: stateId || null,
      },
      finance: isFeatured,
      check_metrics: values?.check_metrics,
      vehicle: vehicleId || null,
      replacement_report: values?.replacement_report,
      remarks: values?.remarks,
      booking_id: bookingId || null,
    }

    if (params?.id) {
      dispatch(updateInspection(inspection, inspectionDetails?._id, history))
    }
  }

  const handleEnters = textEntered => {
    setModelSearch(textEntered)
  }

  function handlerFinalValueModel(event) {
    if (event?.label === "Clear") {
      setModelValue(event.value)
      setModelValueId(null)
    } else {
      setModelValue(event.label)
      setModelValueId(event.value)
    }
  }

  const modelOptions = [
    {
      label: "Clear",
      value: "select a model",
    },
    ,
    {
      options: (model?.length >= 1 ? model : [])?.map((results, index) => ({
        key: index,
        label: results.name,
        value: results._id,
      })),
    },
  ]

  const handleEnter = textEntered => {
    setBrandSearch(textEntered)
  }

  function handlerFinalValuesBrand(event) {
    if (event?.label === "Clear") {
      setBrandValue(event.value)
      setBrandId(null)
    } else {
      setBrandValue(event.label)
      setBrandId(event.value)
    }
  }

  const brandOptions = [
    {
      label: "Clear",
      value: "select a brand",
    },
    {
      options: (brand?.length >= 1 ? brand : [])?.map((results, index) => ({
        key: index,
        label: results.name,
        value: results._id,
      })),
    },
  ]

  const handleEntered = textEntered => {
    setVarientSearch(textEntered)
  }

  function handleFinalValuesVarient(event) {
    if (event?.label === "Clear") {
      setVarientValue(event?.value)
      setVariantId(null)
    } else {
      setVarientValue(event.label)
      setVariantId(event.value)
    }
  }

  const varientOptions = [
    {
      label: "Clear",
      value: "select a varient",
    },
    {
      options: (varient?.length >= 1 ? varient : [])?.map((results, index) => ({
        key: index,
        label: results.name,
        value: results._id,
      })),
    },
  ]

  // brandId
  useEffect(() => {
    setBookingId(updateData?.booking_id || "")
    setBooking(updateData?.booking_id || "Select Booking ...")
    // setIsFeatured(updateData?.finance)

    setStaffId(updateData?.inspection_data?.inspected_by?._id || "")
    setStaff(
      updateData?.inspection_data?.inspected_by?.name || "Select Staff.."
    )
  }, [updateData])
  useEffect(() => {
    if (updateData?.finance !== undefined) {
      setIsFeatured(updateData.finance)
    }
  }, [updateData?.finance])

  // states

  useEffect(() => {
    dispatch(getStates(stateSearch))
  }, [dispatch, stateSearch])

  const stateOptions = [
    {
      options: allState?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result._id,
      })),
    },
  ]

  const handleEnteredStates = textEntered => {
    setStateSearch(textEntered)
  }

  function handleFinalValuesStates(event) {
    setState(event.label)
    setStateId(event.value)
  }
  // district

  useEffect(() => {
    if (stateId) {
      dispatch(getDistricts(stateId, districtSearch))
    }
  }, [dispatch, stateId, districtSearch])

  const districtOptions = [
    {
      options: allDistricts?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result._id,
      })),
    },
  ]

  const handleEnteredDistrict = textEntered => {
    setDistrictSearch(textEntered)
  }

  function handleFinalValuesDistrict(event) {
    setDistrict(event.label)
    setDistrictId(event.value)
  }
  // inspection user staffs
  useEffect(() => {
    dispatch(getDistricts(stateId))
  }, [dispatch, stateId])

  useEffect(() => {
    dispatch(getUsers("", "", staffSearch, "", "inspectionUser"))
  }, [dispatch, staffSearch])

  const staffOptions = [
    // {
    //   label: "All",
    //   value: "",
    // },
    {
      options: allUser?.users?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result._id,
      })),
    },
  ]

  const handleEnteredStaff = textEntered => {
    setStaffSearch(textEntered)
  }

  function handleFinalValuesStaff(event) {
    setStaff(event.label)
    setStaffId(event.value)
    // history.push(updatedLocation)
  }
  // booking inspection id selection
  useEffect(() => {
    dispatch(getInspectionsBooking("", "NEW", "", bookingSearch, ""))
  }, [dispatch, bookingSearch])
  const bookingOptions = [
    // {
    //   label: "All",
    //   value: "",
    // },
    {
      options: AllInspectionBookings?.map((result, index) => ({
        key: index,
        label: result?.booking_id,
        value: result._id,
        name: result?.user_details?.name,
        phone: result?.user_details?.phone,
      })),
    },
  ]

  const handleEnteredBooking = textEntered => {
    setBookingSearch(textEntered)
  }

  function handleFinalValuesBooking(event) {
    setBooking(event)
    setBookingId(event.label)
    setCustomerName(event?.name || "")
    setCustomerPhone(event?.phone)
    // history.push(updatedLocation)
  }
  useEffect(() => {
    setVehicleId(updateData?.vehicle?._id)

    setStateId(updateData?.owner_details?.state?._id)
    setState(updateData?.owner_details?.state?.name)
    setDistrictId(updateData?.owner_details?.district?._id)
    setDistrict(updateData?.owner_details?.district?.name)
  }, [updateData])

  useEffect(() => {
    if (updateData?.vehicle_data?.vehicle_brand) {
      setBrandId(updateData?.vehicle_data?.vehicle_brand?._id || "")
      setBrandValue({
        label:
          updateData?.vehicle_data?.vehicle_brand?.name || "Select Brand...",
        value: updateData?.vehicle_data?.vehicle_brand?._id || "",
      })
    }
    if (updateData?.vehicle_data?.vehicle_model) {
      setModelValue({
        label:
          updateData?.vehicle_data?.vehicle_model?.name || "Select Model...",
        value: updateData?.vehicle_data?.vehicle_model?._id || "",
      })
      setModelValueId(updateData?.vehicle_data?.vehicle_model?._id || "")
    }
    if (updateData?.vehicle_data?.vehicle_variant) {
      setVariantId(updateData?.vehicle_data?.vehicle_variant?._id || "")
      setVarientValue({
        label:
          updateData?.vehicle_data?.vehicle_variant?.name ||
          "Select Variant...",
        value: updateData?.vehicle_data?.vehicle_variant?._id || "",
      })
    } else if (updateData?.vehicle_data?.variant_name || updateData?.vehicle_data?.varient_name) {
      setVarientValue(updateData?.vehicle_data?.variant_name || updateData?.vehicle_data?.varient_name)
      setVariantId(null)
    }
    if (updateData?.vehicle?._id) {
      setVehicleId(updateData?.vehicle?._id)
    }
  }, [updateData])

  const fuelTypeOptions = [
    {
      id: 1,
      label: "DIESEL",
      value: "diesel",
    },
    {
      id: 2,
      label: "PETROL",
      value: "petrol",
    },
    {
      id: 3,

      label: "ELECTRIC",
      value: "electric",
    },
    {
      id: 4,
      label: "CNG",
      value: "cng",
    },
  ]
  useEffect(() => {
    if (updateData?.vehicle_data?.vehicle_fuel_type) {
      const matched = fuelTypeOptions.find(
        s => s.value === updateData?.vehicle_data?.vehicle_fuel_type
      )
      setStatus(matched || null)
    }
  }, [updateData])

  const inspectionSections = [
    {
      title: "1. Vehicle History",
      data: InspectionDocumentsParameters?.vehicleHistory?.items,
      checkMetricIndex: 0,
      isSub: false,
    },
    {
      title: "2. Road Test",
      data: InspectionDocumentsParameters?.roadTest?.items,
      checkMetricIndex: 1,
      isSub: false,
    },
    {
      title: "3. Vehicle Exterior",
      data: InspectionDocumentsParameters?.vehicleExterior?.subHeads,
      checkMetricIndex: 2,
      isSub: true,
    },
    {
      title: "4. Vehicle Interior",
      data: InspectionDocumentsParameters?.vehicleInterior?.subHeads,
      checkMetricIndex: 3,
      isSub: true,
    },
    {
      title: "5. Vehicle Diagnostic",
      data: InspectionDocumentsParameters?.vehicleDiagnostics?.items,
      checkMetricIndex: 4,
    },
    {
      title: "6. Underhood Components",
      data: InspectionDocumentsParameters?.underhoodComponents?.subHeads,
      checkMetricIndex: 5,
      isSub: true,
    },
    {
      title: "7. UnderBody Components",
      data: InspectionDocumentsParameters?.underbodyComponents?.subHeads,
      checkMetricIndex: 6,
      isSub: true,
    },
    {
      title: "8. Final Check",
      data: InspectionDocumentsParameters?.finalChecks?.items,
      checkMetricIndex: 7,
      isSub: false,
    },
  ]
  const [openSections, setOpenSections] = useState([])

  const getGlobalIndex = (sectionIdx, subHeadIdx, itemIdx) => {
    let count = 0
    for (let i = 0; i < sectionIdx; i++) {
      const sec = inspectionSections[i]
      if (sec.isSub && Array.isArray(sec.data)) {
        sec.data.forEach(sub => {
          count += sub.item.length
        })
      } else if (Array.isArray(sec.data)) {
        count += sec.data.length
      }
    }
    // Add previous subHeads in this section
    if (subHeadIdx !== undefined) {
      for (let j = 0; j < subHeadIdx; j++) {
        count +=
          sectionIdx >= 0 && inspectionSections[sectionIdx].data[j].item.length
      }
      count += itemIdx
    } else {
      count += itemIdx
    }
    return count + 1
  }

  return (
    <div>
      <AvForm
        model={{
          check_metrics: updateData?.check_metrics || [],
        }}
        onValidSubmit={(e, v) => {
          handleSubmit(e, v)
        }}
      >
        <Row className="position-relative">
          <>
            <Col xs="12" sm="12" md="12" lg="12">
              <Card className="">
                <CardBody
                  className="my-2 mx-1 custom-card"
                // style={{ position: "relative" }}
                >
                  <>
                    <Row>
                      <Col className="d-flex justify-content-end">
                        <Button
                          className="px-5 btn-rounded mb-4"
                          color="warning"
                          type="submit"
                          // style={{ width: "fit-content" }}
                          style={{ width: "150px" }}
                          disabled={loadingCreate}
                        >
                          {loadingCreate ? (
                            <>
                              <div
                                className="spinner-border text-light"
                                role="status"
                                style={{ width: "1rem", height: "1rem" }}
                              />
                            </>
                          ) : (
                            "Save "
                          )}
                        </Button>
                      </Col>
                    </Row>

                    <Row className="bg-light px-1 py-2 mb-3 heading-document">
                      <Col>
                        <span>INSPECTION DATA</span>
                      </Col>
                    </Row>
                    <Row className="pt-2 mb-3 mt-3">
                      <Col md={4}>
                        <label>
                          Inspection Date
                          <span className="text-danger">*</span>
                        </label>
                        <AvField
                          name="inspected_date"
                          // label="Inspection Date"
                          placeholder="Enter Inspection Date.."
                          type="date"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: "Inspection Date is required",
                            },
                          }}
                          value={new Date().toISOString().split("T")[0]}
                        />
                      </Col>

                      <Col md={4}>
                        <label>Inspected By</label>
                        <Select
                          onInputChange={handleEnteredStaff}
                          value={staff}
                          placeholder={staff}
                          onChange={handleFinalValuesStaff}
                          options={staffOptions}
                          classNamePrefix="select2-selection"
                          isLoading={""}
                        />
                      </Col>
                      <Col md={4}>
                        <label>Inspection Booking</label>
                        <Select
                          onInputChange={handleEnteredBooking}
                          value={booking}
                          placeholder={booking}
                          onChange={handleFinalValuesBooking}
                          options={bookingOptions}
                          classNamePrefix="select2-selection"
                          isLoading={""}
                        />
                      </Col>
                    </Row>
                    <Row className="bg-light px-1 py-2 mb-3 heading-document">
                      <Col>
                        <span>VEHICLE DATA</span>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <label>
                          Vehicle Brand
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          onInputChange={handleEnter}
                          value={brandValue || null}
                          placeholder={brandValue}
                          onChange={handlerFinalValuesBrand}
                          options={brandOptions}
                          classNamePrefix="select2-selection"
                          isRequired={true}
                        />
                      </Col>
                      <Col>
                        <label> Vehicle Model</label>
                        <Select
                          onInputChange={handleEnters}
                          value={modelValue || null}
                          placeholder={modelValue}
                          onChange={handlerFinalValueModel}
                          options={modelOptions}
                          classNamePrefix="select2-selection"
                          isRequired={true}
                        />
                      </Col>

                      <>
                        <Col>
                          <label>Search Variant</label>
                          <Select
                            onInputChange={handleEntered}
                            value={
                              variantId
                                ? {
                                  label:
                                    typeof varientValue === "object"
                                      ? varientValue.label
                                      : varientValue,
                                  value: variantId,
                                }
                                : null
                            }
                            placeholder="Search variant..."
                            onChange={handleFinalValuesVarient}
                            options={varientOptions}
                            classNamePrefix="select2-selection"
                          />
                        </Col>

                      </>

                      <Col>
                        <label>Vehicle Variant</label>
                        <AvField
                          name="vehicle_variant_text"
                          value={
                            varientValue === "Select Variant..." ||
                              varientValue === "Select Vehicle Variant"
                              ? ""
                              : typeof varientValue === "object"
                                ? varientValue.label
                                : varientValue
                          }
                          onChange={e => {
                            setVarientValue(e.target.value)
                            setVariantId(null)
                          }}
                          placeholder="Enter Vehicle Variant"
                          type="text"
                        />
                      </Col>

                      <Col>
                        <label>
                          Registration Number
                          <span className="text-danger">*</span>
                        </label>
                        <AvField
                          name="vehicle_number"
                          placeholder="Enter Vehicle Number"
                          type="text"
                          value={updateData?.vehicle_data?.vehicle_number}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: "Vehicle Number is required",
                            },
                          }}
                        />
                      </Col>
                    </Row>
                    <Row className="pt-3">
                      <Col md={3}>
                        <label>Vehicle Name</label>
                        <AvField
                          name="vehicle_name"
                          placeholder="Enter Vehicle Name"
                          type="text"
                          value={updateData?.vehicle_data?.vehicle_name}
                        />
                      </Col>

                      <Col md={3}>
                        <label>Year</label>
                        <AvField
                          name="vehicle_year"
                          placeholder="Enter Vehicle Year"
                          type="text"
                          value={updateData?.vehicle_data?.vehicle_year || ""}
                        />
                      </Col>

                      <Col md={3}>
                        <label>KMs</label>
                        <AvField
                          name="current_kilometer"
                          placeholder="Current KMs"
                          type="text"
                          value={
                            updateData?.vehicle_data?.current_kilometer || ""
                          }
                        />
                      </Col>
                      <Col md={3}>
                        <label>Fuel Type</label>

                        <Select
                          value={status}
                          onChange={setStatus}
                          options={fuelTypeOptions}
                          classNamePrefix="select2-selection"
                          placeholder="Select Fuel Type"
                        />
                      </Col>
                    </Row>
                    <Row className="bg-light px-1 mt-3 py-2 mb-3 heading-document">
                      <Col>
                        <span>OWNER DETAILS</span>
                      </Col>
                    </Row>
                  </>

                  <>
                    <Row>
                      <Col xs={12} md={8}>
                        <Row>
                          <Col md={6}>
                            <label>
                              Customer Name
                              <span className="text-danger">*</span>
                            </label>
                            <AvField
                              name="customer_name"
                              onChange={e => setCustomerName(e.target.value)}
                              placeholder="Enter Customer Name"
                              // value={updateData?.owner_details?.customer_name}
                              value={customerName}
                              type="text"
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Customer Name is required",
                                },
                              }}
                            />
                          </Col>
                          <Col md={6}>
                            <label>
                              Phone
                              <span className="text-danger">*</span>
                            </label>
                            <AvField
                              onChange={e => setCustomerPhone(e.target.value)}
                              value={customerPhone}
                              name="phone_number"
                              placeholder="Enter Phone Number"
                              type="text"
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Phone Number is required",
                                },
                              }}
                              pattern="^[0-9]{10}$"
                              errorMessage="Phone Number must be 10 digits"
                              maxLength="10"
                              minLength="10"
                            />
                          </Col>
                        </Row>
                        <Row className="" style={{ marginTop: "12px" }}>
                          <Col md={6}>
                            <label>State</label>

                            <Select
                              onInputChange={handleEnteredStates}
                              value={state}
                              placeholder={state}
                              onChange={handleFinalValuesStates}
                              options={stateOptions}
                              classNamePrefix="select2-selection"
                              isLoading={""}
                            />
                          </Col>
                          <Col md={6}>
                            <label>District</label>
                            <Select
                              onInputChange={handleEnteredDistrict}
                              value={district}
                              isDisabled={!stateId}
                              placeholder={district}
                              onChange={handleFinalValuesDistrict}
                              options={districtOptions}
                              classNamePrefix="select2-selection"
                              isLoading={""}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={12} md={4}>
                        <label>Address</label>
                        <AvField
                          name="address"
                          placeholder="Enter Address.."
                          value={updateData?.owner_details?.address}
                          type="textarea"
                          rows="5"
                        />
                      </Col>
                    </Row>
                  </>

                  <>
                    <Row className="bg-light px-1 mt-3 py-2 mb-1 heading-document">
                      <Col>
                        <span>OTHER DETAILS</span>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6} className="d-flex align-items-end">
                        <div className="d-flex flex-column justify-content-center h-100 gap-1">
                          <Label className="mb-0">Finance</Label>
                          <div className="d-flex align-items-center gap-3 mx-2">
                            <Label className="d-flex align-items-center gap-1 mb-0">
                              <Input
                                type="radio"
                                name="finance"
                                value="yes"
                                checked={isFeatured === true}
                                onChange={() => setIsFeatured(true)}
                              />
                              Yes
                            </Label>
                            <Label className="d-flex align-items-center gap-1 mb-0">
                              <Input
                                type="radio"
                                name="finance"
                                value="no"
                                checked={isFeatured === false}
                                onChange={() => setIsFeatured(false)}
                              />
                              No
                            </Label>
                          </div>
                        </div>
                      </Col>
                      <Col md={6} className="">
                        <AvField
                          name="replacement_report"
                          value={updateData?.replacement_report}
                          label="Replacement Report"
                          placeholder="Enter Details"
                          type="textarea"
                          rows="2"
                        // maxLength="85"
                        />
                      </Col>
                    </Row>
                  </>

                  <Row className="pt-3 mb-2">
                    {inspectionSections.map((section, idx) => (
                      <div key={section.title}>
                        <Col
                          className="mb-2"
                          onClick={() => {
                            if (openSections.includes(idx)) {
                              setOpenSections(
                                openSections.filter(i => i !== idx)
                              )
                            } else {
                              setOpenSections([...openSections, idx])
                            }
                          }}
                          style={{
                            backgroundColor: "#FFF1DC",
                            color: "#B36200",
                            fontWeight: "500",
                            fontSize: "16px",
                            letterSpacing: "0.5px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "8px 12px",
                          }}
                        >
                          <span style={{ textTransform: "uppercase" }}>
                            {section.title}
                          </span>
                          <i
                            className={`mdi ${openSections.includes(idx)
                              ? "mdi-chevron-up"
                              : "mdi-chevron-down"
                              }`}
                            style={{ fontSize: "20px" }}
                          />
                        </Col>
                        <div
                          style={{
                            display: openSections.includes(idx)
                              ? "block"
                              : "none",
                          }}
                        >
                          {/* If section has subHeads, render nested accordions */}
                          {section.isSub && Array.isArray(section.data)
                            ? section.data.map((sub, subHeadIdx) => (
                              <div key={sub.title}>
                                <div
                                  style={{
                                    background: "#EFF2F7",
                                    color: "#343A40",
                                    fontWeight: "bold",
                                    padding: "8px 12px",
                                    // borderRadius: 4,
                                    margin: "8px 0 4px 0",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                  }}
                                  onClick={() => {
                                    // Toggle subHead open/close
                                    const key = `${idx}-${subHeadIdx}`
                                    setOpenSections(
                                      openSections.includes(key)
                                        ? openSections.filter(i => i !== key)
                                        : [...openSections, key]
                                    )
                                  }}
                                >
                                  {sub.title}
                                  <i
                                    className={`mdi ${openSections.includes(
                                      `${idx}-${subHeadIdx}`
                                    )
                                      ? "mdi-chevron-up"
                                      : "mdi-chevron-down"
                                      }`}
                                    style={{
                                      fontSize: "16px",
                                      float: "right",
                                    }}
                                  />
                                </div>
                                <div
                                  style={{
                                    display: openSections.includes(
                                      `${idx}-${subHeadIdx}`
                                    )
                                      ? "block"
                                      : "none",
                                  }}
                                >
                                  {sub.item.map((item, itemIdx) => (
                                    <React.Fragment key={itemIdx}>
                                      <div
                                        style={{
                                          minWidth: isTablet ? 380 : 480,
                                          borderRadius: 6,
                                          padding: "8px",
                                        }}
                                        className="mb-2 d-flex align-items-center"
                                      >
                                        <div
                                          className="d-flex align-items-center"
                                          style={{
                                            minWidth: isTablet ? 380 : 480,
                                          }}
                                        >
                                          <p
                                            className="mb-0"
                                            style={{
                                              fontSize: "13px",
                                              color: "#1C252E",
                                            }}
                                          >
                                            {/* {itemIdx + 1}. &nbsp; */}
                                            {section.isSub
                                              ? getGlobalIndex(
                                                idx,
                                                subHeadIdx,
                                                itemIdx
                                              )
                                              : getGlobalIndex(
                                                idx,
                                                undefined,
                                                index
                                              )}
                                            . &nbsp;
                                          </p>
                                          <p
                                            className="mb-0"
                                            style={{
                                              fontSize: "13px",
                                              color: "#1C252E",
                                            }}
                                          >
                                            {item}
                                          </p>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center pt-1 w-100">
                                          <div
                                            className=""
                                            style={{ marginBottom: "-2px" }}
                                          >
                                            <AvField
                                              className="custom-green-checkbox"
                                              type="checkbox"
                                              name={`check_metrics[${section.checkMetricIndex}].section.parameters[${subHeadIdx}].sub_parameters[${itemIdx}].status`}
                                              checked={
                                                updateData?.check_metrics?.[
                                                  section.checkMetricIndex
                                                ]?.section?.parameters?.[
                                                  subHeadIdx
                                                ]?.sub_parameters?.[itemIdx]
                                                  ?.status ?? false
                                              }
                                            />
                                          </div>
                                          <p
                                            className="pe-2 mb-0"
                                            style={{
                                              whiteSpace: "nowrap",
                                              marginTop: "2px",
                                            }}
                                          >
                                            &nbsp; Good
                                          </p>
                                          <div
                                            className="w-100"
                                            style={{ marginLeft: "8px" }}
                                          >
                                            <AvField
                                              style={{
                                                border: "1px solid #ccc",
                                                minHeight: "40px",
                                              }}
                                              placeholder="Enter Details"
                                              type="text"
                                              // maxLength="32"
                                              // rows="1"
                                              name={`check_metrics[${section.checkMetricIndex}].section.parameters[${subHeadIdx}].sub_parameters[${itemIdx}].value`}
                                              value={
                                                updateData?.check_metrics?.[
                                                  section.checkMetricIndex
                                                ]?.section?.parameters?.[
                                                  subHeadIdx
                                                ]?.sub_parameters?.[itemIdx]
                                                  ?.value ?? ""
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      {itemIdx !== sub.item.length - 1 && (
                                        <hr
                                          style={{
                                            border: "none",
                                            borderTop: "1px dotted grey",
                                            margin: "0 0 8px 0",
                                          }}
                                        />
                                      )}
                                    </React.Fragment>
                                  ))}
                                </div>
                              </div>
                            ))
                            : // No subHeads, render items directly
                            section.data?.map((i, index) => (
                              <React.Fragment key={index}>
                                <div
                                  style={{
                                    minWidth: isTablet ? 380 : 480,
                                    borderRadius: 6,
                                    padding: "8px",
                                  }}
                                  className="mb-2 d-flex align-items-center"
                                >
                                  <div
                                    className="d-flex align-items-center"
                                    style={{ minWidth: isTablet ? 380 : 480 }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontSize: "13px",
                                        color: "#1C252E",
                                      }}
                                    >
                                      {getGlobalIndex(idx, undefined, index)}.
                                      &nbsp;
                                    </p>
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontSize: "13px",
                                        color: "#1C252E",
                                      }}
                                    >
                                      {section?.isSub ? i?.item : i}
                                    </p>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-center pt-1 w-100">
                                    <div
                                      className=""
                                      style={{ marginBottom: "-2px" }}
                                    >
                                      <AvField
                                        className="custom-green-checkbox"
                                        type="checkbox"
                                        name={`check_metrics[${section.checkMetricIndex}].section.parameters[${index}].status`}
                                        checked={
                                          updateData?.check_metrics?.[
                                            section.checkMetricIndex
                                          ]?.section?.parameters?.[index]
                                            ?.status ?? false
                                        }
                                      />
                                    </div>
                                    <p
                                      className="pe-2 mb-0"
                                      style={{
                                        whiteSpace: "nowrap",
                                        marginTop: "2px",
                                      }}
                                    >
                                      &nbsp; Good
                                    </p>
                                    <div
                                      className="w-100"
                                      style={{ marginLeft: "8px" }}
                                    >
                                      <AvField
                                        style={{
                                          border: "1px solid #ccc",
                                          minHeight: "40px",
                                        }}
                                        placeholder="Enter Details"
                                        type="text"
                                        // maxLength="32"
                                        // rows="1"
                                        name={`check_metrics[${section.checkMetricIndex}].section.parameters[${index}].value`}
                                        value={
                                          updateData?.check_metrics?.[
                                            section.checkMetricIndex
                                          ]?.section?.parameters?.[index]
                                            ?.value ?? ""
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                                {index !== section.data.length - 1 && (
                                  <hr
                                    style={{
                                      border: "none",
                                      borderTop: "1px dotted grey",
                                      margin: "0 0 8px 0",
                                    }}
                                  />
                                )}
                              </React.Fragment>
                            ))}
                        </div>
                      </div>
                    ))}
                  </Row>

                  <Row>
                    <Col md={6} />
                    <Col md={6}>
                      <div className="pt-1">
                        <AvField
                          name="remarks"
                          value={updateData?.remarks}
                          label="Remarks"
                          placeholder="Enter Remarks"
                          type="textarea"
                          rows="4"
                        // maxLength="85"
                        />
                      </div>
                    </Col>
                  </Row>

                  <div
                    className="d-flex align-items-center text-center "
                    style={{ marginTop: "1px" }}
                  >
                    <hr className="flex-grow-1 solid-line" />
                  </div>
                  <Row className="align-items-center justify-content-center">
                    <Col
                      lg={2}
                      md={3}
                      className="px-1"
                      style={{
                        width: "fit-content",
                        zIndex: 1000,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "end",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div className="w-100 d-flex align-items-center justify-content-start py-2 mb-0">
                        <Button
                          className="w-100 px-5 btn-rounded "
                          color="outline-warning"
                          onClick={() => history.goBack()}
                        >
                          {"close"}
                        </Button>
                      </div>
                    </Col>
                    <Col
                      lg={2}
                      md={3}
                      className=""
                      style={{
                        // width: "fit-content",
                        zIndex: 1000,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        justifyContent: "flex-start",
                      }}
                    >
                      <Button
                        className=" px-5 btn-rounded  fixed-width-button"
                        color="warning"
                        type="submit"
                        style={{ width: "200px !important" }}
                        disabled={loadingCreate}
                      >
                        {loadingCreate ? (
                          <div
                            className="spinner-border text-light"
                            role="status"
                            style={{ width: "1rem", height: "1rem" }}
                          />
                        ) : (
                          "Submit"
                        )}{" "}
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </>
        </Row>
      </AvForm>
    </div>
  )
}

export default UpdateForm

UpdateForm.propTypes = {
  updateData: PropTypes.any,
}
